module.exports = __webpack_public_path__ + "img/65.bcf401c7.png";